module.exports = __webpack_public_path__ + "static/media/debug.fragment.83a2b17c.glsl";